const nav = [
    {
        to: '/about',
        name: 'About',
    },
    {
        to: '/experience',
        name: 'Experience',
    },
    {
        to: '/education',
        name: 'Education',
    },
    {
        to: '/skills-projects',
        name: 'Skills & Projects',
    },
    {
        to: '/achievements',
        name: 'Achievements',
    },
];

export { nav };
